export default "__VITE_ASSET__DCW5tsGq__"